@if (product$ | async; as product) {
  <div class="container product-details-container">
    @if (product?.description) {
      <div class="description" [innerHTML]="product?.description"></div>
    }
    @if (product?.imageTextShort) {
      <div class="imageTextShort" [innerHTML]="product?.imageTextShort | safeHtml"></div>
    }
    @if (product?.imageTextLong) {
      <div class="imageTextLong" [innerHTML]="product?.imageTextLong | safeHtml"></div>
    }
    @if (product?.marketingText1) {
      <div class="marketingText1" [innerHTML]="product?.marketingText1 | safeHtml"></div>
    }
    @if (product?.marketingText2) {
      <div class="marketingText2" [innerHTML]="product?.marketingText2 | safeHtml"></div>
    }
  </div>
}
